import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import AppNavbar from "../../../components/common/AppNavbar";

/* ══ Single AdSense Unit ══ */
const AdUnit = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }, []);
  return (
    <div className="ad-wrapper">
      <div className="ad-label">Advertisement</div>
      <ins
        className="adsbygoogle"
        style={{ display: "inline-block", width: "300px", height: "300px" }}
        data-ad-client="ca-pub-8585027130601823"
        data-ad-slot="7838136769"
      />
    </div>
  );
};

const BharatAbroadWeeklyNewsletter = () => {
  return (
    <>
      <Helmet>
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8585027130601823"
          crossOrigin="anonymous"
        />
        <html lang="en" />
        <title>
          BharatAbroad Weekly Newsletter | Diaspora, Immigration, Sports &
          Business Updates – Bharat Abroad
        </title>
        <meta
          name="description"
          content="This week's BharatAbroad newsletter covers PM Modi's Indonesia, Australia & New Zealand visit, the India-Japan strategic summit, US EB-2 quota exhaustion and Canada student visa cuts, India's tour of England, the India-UK trade pact, Quantum Valley's IBM quantum computer, and falling jet fuel prices for Indians abroad."
        />
        <meta
          name="keywords"
          content="BharatAbroad newsletter, Indian diaspora news, PM Modi Indonesia Australia New Zealand visit, India Japan summit, EB-2 visa quota exhausted, Canada international student cuts, India tour of England cricket, India UK trade pact, Quantum Valley IBM quantum computer, ATF jet fuel price cut, Indian professionals abroad, NRI news weekly"
        />
        <meta name="author" content="Bharat Abroad Editorial" />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <meta name="theme-color" content="#0f2027" />
        <link
          rel="canonical"
          href="https://www.bharatabroad.com/newsletter/weekly-july-2026"
        />
        <meta name="geo.region" content="IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="BharatAbroad Weekly Newsletter | Diaspora, Immigration, Sports & Business – July 2026"
        />
        <meta
          property="og:description"
          content="PM Modi's Indo-Pacific tour, the India-Japan summit, EB-2 quota exhaustion, Canada's student visa cuts, India in England, Quantum Valley's IBM computer, and cheaper jet fuel — your weekly digest for Indians abroad."
        />
        <meta
          property="og:url"
          content="https://www.bharatabroad.com/newsletter/weekly-july-2026"
        />
        <meta property="og:site_name" content="Bharat Abroad" />
        <meta property="og:locale" content="en_IN" />
        <meta
          property="og:image"
          content="https://www.bharatabroad.com/images/newsletter/weekly-july-2026-og.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="article:published_time"
          content="2026-07-07T00:00:00+05:30"
        />
        <meta
          property="article:modified_time"
          content="2026-07-07T00:00:00+05:30"
        />
        <meta property="article:section" content="Newsletter" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@BharatAbroad" />
        <meta
          name="twitter:title"
          content="BharatAbroad Weekly Newsletter — July 2026"
        />
        <meta
          name="twitter:description"
          content="PM Modi's Indo-Pacific tour, India-Japan summit, EB-2 quota exhaustion, Canada student visa cuts, India in England, Quantum Valley, and falling jet fuel prices for Indians abroad."
        />
        <meta
          name="twitter:image"
          content="https://www.bharatabroad.com/images/newsletter/weekly-july-2026-og.jpg"
        />
        <script type="application/ld+json">{`
          {
            "@context":"https://schema.org","@type":"Article",
            "headline":"BharatAbroad Weekly Newsletter — Diaspora, Immigration, Sports & Business Updates",
            "datePublished":"2026-07-07T00:00:00+05:30","dateModified":"2026-07-07T00:00:00+05:30",
            "author":{"@type":"Organization","name":"Bharat Abroad Editorial","url":"https://www.bharatabroad.com/about"},
            "publisher":{"@type":"Organization","name":"Bharat Abroad","url":"https://www.bharatabroad.com","logo":{"@type":"ImageObject","url":"https://www.bharatabroad.com/images/logo/bharatabroad-logo.png","width":200,"height":60}},
            "mainEntityOfPage":{"@type":"WebPage","@id":"https://www.bharatabroad.com/newsletter/weekly-july-2026"},
            "image":{"@type":"ImageObject","url":"https://www.bharatabroad.com/images/newsletter/weekly-july-2026-og.jpg","width":1200,"height":630},
            "inLanguage":"en-IN","articleSection":"Newsletter"
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context":"https://schema.org","@type":"BreadcrumbList",
            "itemListElement":[
              {"@type":"ListItem","position":1,"name":"Home","item":"https://www.bharatabroad.com"},
              {"@type":"ListItem","position":2,"name":"Newsletter","item":"https://www.bharatabroad.com/newsletter"},
              {"@type":"ListItem","position":3,"name":"Weekly Update July 2026","item":"https://www.bharatabroad.com/newsletter/weekly-july-2026"}
            ]
          }
        `}</script>
      </Helmet>

      <AppNavbar />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Source+Serif+4:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Barlow:wght@400;500;600&display=swap');

        /* ── Reset ── */
        .news-page * { box-sizing: border-box; }
        .news-page { background: #f7f5f0; font-family: 'Source Serif 4', serif; color: #1a1a1a; }

        /* ══════════════════
           HERO / BANNER
        ══════════════════ */
        .news-hero {
          background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
          color: #fff;
          padding: 52px 0 44px;
          border-bottom: 4px solid #c8a84b;
        }
        .news-hero-eyebrow {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #c8a84b;
          margin-bottom: 14px;
        }
        .news-hero h1 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(28px, 5vw, 52px);
          font-weight: 900;
          line-height: 1.1;
          color: #fff;
          margin-bottom: 16px;
          letter-spacing: -0.5px;
        }
        .news-hero-sub {
          font-family: 'Source Serif 4', serif;
          font-size: clamp(14px, 2vw, 17px);
          font-weight: 300;
          font-style: italic;
          color: rgba(255,255,255,0.7);
          max-width: 720px;
          line-height: 1.65;
        }
        .news-hero-meta {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-top: 24px;
          padding-top: 20px;
          border-top: 1px solid rgba(255,255,255,0.12);
          flex-wrap: wrap;
        }
        .news-hero-meta span {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          color: rgba(255,255,255,0.45);
          letter-spacing: 0.05em;
          text-transform: uppercase;
        }
        .news-hero-meta .sep { color: rgba(255,255,255,0.15); }

        /* ══════════════════
           CATEGORY TABS
        ══════════════════ */
        .news-tabs {
          background: #fff;
          border-bottom: 1px solid #e0dbd0;
          position: sticky;
          top: 0;
          z-index: 100;
        }
        .news-tabs-inner {
          display: flex;
          gap: 0;
          overflow-x: auto;
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .news-tabs-inner::-webkit-scrollbar { display: none; }
        .news-tab {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #666;
          padding: 14px 20px;
          white-space: nowrap;
          border-bottom: 3px solid transparent;
          cursor: default;
          transition: color 0.2s, border-color 0.2s;
        }
        .news-tab.active {
          color: #0f2027;
          border-bottom-color: #c8a84b;
        }

        /* ══════════════════
           MAIN LAYOUT
        ══════════════════ */
        .news-body { padding: 48px 0 72px; }
        .news-grid {
          display: grid;
          grid-template-columns: 1fr 300px;
          gap: 40px;
          align-items: start;
        }

        /* ══════════════════
           SECTION BLOCK
        ══════════════════ */
        .news-section { margin-bottom: 48px; }
        .news-section-head {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          padding-bottom: 12px;
          border-bottom: 2px solid #1a1a1a;
        }
        .news-section-tag {
          font-family: 'Barlow', sans-serif;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #fff;
          background: #0f2027;
          padding: 3px 10px;
          border-radius: 3px;
        }
        .news-section-tag.gold  { background: #c8a84b; color: #1a1a1a; }
        .news-section-tag.green { background: #1a5c38; }
        .news-section-tag.red   { background: #9b1b1b; }
        .news-section-tag.blue  { background: #1a3a6b; }
        .news-section-tag.teal  { background: #1a5c4a; }

        /* ══════════════════
           LEAD ARTICLE
        ══════════════════ */
        .lead-article { margin-bottom: 28px; }
        .lead-article h2 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(20px, 3.5vw, 28px);
          font-weight: 800;
          color: #0f2027;
          line-height: 1.25;
          margin-bottom: 10px;
          letter-spacing: -0.3px;
        }
        .lead-article .deck {
          font-size: 16px;
          font-weight: 300;
          font-style: italic;
          color: #555;
          line-height: 1.7;
          margin-bottom: 14px;
          border-left: 3px solid #c8a84b;
          padding-left: 14px;
        }
        .article-body p {
          font-size: 15.5px;
          line-height: 1.85;
          color: #2a2a2a;
          margin-bottom: 14px;
          font-weight: 300;
        }

        /* ══════════════════
           NEWS BULLETS
        ══════════════════ */
        .news-bullets { margin: 0; padding: 0; list-style: none; }
        .news-bullets li {
          display: flex;
          gap: 12px;
          padding: 13px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 15px;
          line-height: 1.7;
          color: #2a2a2a;
          font-weight: 300;
        }
        .news-bullets li:last-child { border-bottom: none; }
        .bullet-dash {
          font-family: 'Barlow', sans-serif;
          font-weight: 700;
          color: #c8a84b;
          font-size: 18px;
          line-height: 1.5;
          flex-shrink: 0;
        }

        /* ══════════════════
           HIGHLIGHT BOX
        ══════════════════ */
        .news-highlight {
          background: #0f2027;
          color: #fff;
          border-radius: 4px;
          padding: 22px 24px;
          margin: 20px 0;
        }
        .news-highlight-label {
          font-family: 'Barlow', sans-serif;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          color: #c8a84b;
          margin-bottom: 10px;
        }
        .news-highlight p {
          font-family: 'Playfair Display', serif;
          font-size: 18px;
          font-style: italic;
          color: #fff;
          line-height: 1.65;
          margin: 0;
        }

        /* ══════════════════
           CRICKET SCORE BOX
        ══════════════════ */
        .cricket-box {
          border: 2px solid #1a1a1a;
          border-radius: 4px;
          overflow: hidden;
          margin: 16px 0;
        }
        .cricket-box-head {
          background: #1a1a1a;
          color: #fff;
          padding: 10px 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .cricket-box-title {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        .cricket-live {
          background: #c8a84b;
          color: #1a1a1a;
          font-family: 'Barlow', sans-serif;
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 3px 8px;
          border-radius: 2px;
        }
        .cricket-box-body {
          background: #fff;
          padding: 16px;
        }
        .cricket-box-body p {
          font-size: 14.5px;
          color: #333;
          line-height: 1.7;
          margin: 0;
          font-weight: 300;
        }

        /* ══════════════════
           SIDEBAR
        ══════════════════ */
        .news-sidebar { position: sticky; top: 56px; }

        .sidebar-widget { margin-bottom: 32px; }
        .sidebar-widget-head {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #fff;
          background: #0f2027;
          padding: 6px 12px;
          margin-bottom: 14px;
          display: inline-block;
        }

        /* Quick facts */
        .quick-facts { list-style: none; padding: 0; margin: 0; }
        .quick-facts li {
          padding: 10px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 13.5px;
          line-height: 1.6;
          color: #333;
          font-weight: 300;
          display: flex;
          gap: 8px;
          align-items: flex-start;
        }
        .quick-facts li:last-child { border-bottom: none; }
        .qf-bullet {
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #c8a84b;
          flex-shrink: 0;
          margin-top: 6px;
        }

        /* Stat widget */
        .stat-widget {
          background: #fff;
          border: 1px solid #e0dbd0;
          border-radius: 4px;
          overflow: hidden;
        }
        .stat-widget-item {
          padding: 14px 16px;
          border-bottom: 1px solid #e0dbd0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .stat-widget-item:last-child { border-bottom: none; }
        .stat-widget-label {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          color: #888;
        }
        .stat-widget-val {
          font-family: 'Playfair Display', serif;
          font-size: 20px;
          font-weight: 700;
          color: #0f2027;
        }
        .stat-widget-delta {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          color: #1a5c38;
        }

        /* Ad wrapper */
        .ad-wrapper {
          background: #fff;
          border: 1px solid #e0dbd0;
          border-radius: 4px;
          padding: 16px;
          text-align: center;
        }
        .ad-label {
          font-family: 'Barlow', sans-serif;
          font-size: 9px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #bbb;
          margin-bottom: 10px;
          font-weight: 600;
        }

        /* ══════════════════
           RESPONSIVE
        ══════════════════ */
        @media (max-width: 900px) {
          .news-grid { grid-template-columns: 1fr; }
          .news-sidebar { position: static; }
        }
        @media (max-width: 600px) {
          .news-hero { padding: 36px 0 32px; }
          .news-body { padding: 32px 0 56px; }
          .news-section { margin-bottom: 36px; }
        }
      `}</style>

      <div className="news-page">
        {/* ════════ HERO ════════ */}
        <div className="news-hero">
          <Container>
            <div className="news-hero-eyebrow">
              📰 BharatAbroad Weekly Newsletter · July 2026
            </div>
            <h1>BharatAbroad Weekly Newsletter</h1>
            <p className="news-hero-sub">
              Here is your quick and simple update on important news from Bharat
              and around the world. This week's focus includes diaspora and
              diplomacy updates, immigration news, cricket, and business
              developments.
            </p>
            <div className="news-hero-meta">
              <span>🕐 5 min read</span>
              <span className="sep">·</span>
              <span>📅 July 7, 2026</span>
              <span className="sep">·</span>
              <span>✍️ Bharat Abroad Editorial</span>
            </div>
          </Container>
        </div>

        {/* ════════ CATEGORY TABS ════════ */}

        {/* ════════ BODY ════════ */}
        <div className="news-body">
          <Container>
            <div className="news-grid">
              {/* ══ MAIN COLUMN ══ */}
              <main>
                {/* ── Section 1: Diaspora ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag gold">
                      🌏 International Relations &amp; Diaspora
                    </span>
                  </div>

                  <div className="lead-article">
                    <h2>
                      PM Modi's Indo-Pacific Tour Strengthens Bharat's Ties
                      Across Asia and Oceania
                    </h2>
                    <p className="deck">
                      Visits to Indonesia, Australia, and New Zealand — paired
                      with a landmark summit with Japan — signal Bharat's
                      deepening trade, defence, and technology partnerships
                      across the Indo-Pacific.
                    </p>
                    <div className="article-body">
                      <p>
                        Our Honorable Prime Minister Narendra Modi Ji's visit to
                        Indonesia, Australia, and New Zealand is expected to
                        boost trade, defence, and maritime security ties across
                        the region, with officials noting that facilitating the
                        movement of high-skilled Bharat professionals is a key
                        priority ahead of the New Zealand leg. Separately, the
                        16th India-Japan Annual Summit delivered a first-ever
                        defence co-development project, a joint statement on AI,
                        and more than $10 billion in fresh Japanese investment
                        commitments, marking one of the most substantive
                        deepenings of the two countries' strategic partnership
                        to date.
                      </p>
                    </div>
                  </div>

                  <div className="news-highlight">
                    <div className="news-highlight-label">
                      🤝 Trade Ties Widen Further
                    </div>
                    <p>
                      The finance ministry has notified rules of origin for the{" "}
                      <strong>India-UK trade pact</strong>, clearing the way for
                      implementation from July 15 — following closely on the
                      heels of the recently concluded{" "}
                      <strong>India-EU free trade agreement</strong>, with
                      officials aiming to conclude a Canada FTA within six
                      months.
                    </p>
                  </div>
                </div>

                {/* ── Section 2: Immigration ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag blue">
                      🛂 Immigration Updates
                    </span>
                  </div>

                  <div className="article-body">
                    <p>
                      Immigration remains a major concern for Indians living
                      abroad, with several notable shifts this week.
                    </p>
                  </div>

                  <ul className="news-bullets">
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>EB-2 quota exhausted.</strong> The US Department
                        of State has confirmed the EB-2 (Employment-Based Second
                        Preference) visa quota for India is entirely exhausted
                        for Fiscal Year 2026, deepening the multi-year green
                        card backlog facing Bharat National applicants.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>US naturalization costs rising.</strong> A
                        Department of Homeland Security plan under discussion
                        would raise the cost of US citizenship applications and
                        eliminate most fee waivers for low-income applicants — a
                        change Bharat families should factor into long-term
                        planning.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>Student visa extensions.</strong> A separate
                        proposed DHS regulation could require international
                        students to formally seek extensions for study programs
                        lasting beyond four years, adding a new compliance step
                        for those on longer academic tracks.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>Canada tightens student pathways.</strong>
                        Canada has cut its international student target to
                        408,000 study permits for the year — down 7% from 2025 —
                        discontinued the fast-track Student Direct Stream, and
                        raised the minimum proof-of-funds requirement to CAD
                        $22,895, raising the bar for middle-class Bharat
                        applicants.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>Schengen visa demand</strong> remains high,
                        continuing to cause appointment delays for Bharat
                        National travelers to Europe.
                      </span>
                    </li>
                  </ul>
                </div>

                {/* ── Section 3: Sports ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag green">
                      🏏 Sports - Cricket
                    </span>
                  </div>

                  <div className="cricket-box">
                    <div className="cricket-box-head">
                      <span className="cricket-box-title">
                        India Tour of England 2026 — T20I Series
                      </span>
                      <span className="cricket-live">● Series Live</span>
                    </div>
                    <div className="cricket-box-body">
                      <p>
                        England leads India 1-0 in the five-match T20I series,
                        with the third T20I set for Nottingham on July 7.
                        Teenage sensation Vaibhav Sooryavanshi has drawn
                        attention with sharp cameos at the top of the order,
                        while questions continue over India's bowling
                        combinations. The tour continues with two more T20Is
                        before the squads shift to a three-match ODI series
                        starting July 14 in Birmingham, including a stop at
                        Lord's on July 19.
                      </p>
                    </div>
                  </div>
                </div>

                {/* ── Section 4: Economy ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag teal">
                      💼 Economy, Business &amp; Technology
                    </span>
                  </div>

                  <ul className="news-bullets">
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        Andhra Pradesh's <strong>Quantum Valley</strong> project
                        has landed a major milestone: IBM will set up one of
                        India's first quantum computers in Amaravati by
                        September 2026, anchoring the tech park with
                        infrastructure for pharmaceuticals, cybersecurity, and
                        financial-services research.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        The <strong>World Bank</strong> has approved $1.5
                        billion in financing to support private sector-led job
                        creation in India, aiming to help generate employment
                        for the 11 million young Indians entering the workforce
                        each year over the next two decades.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        India's merchandise exports rose roughly 15% during
                        April–June, with May exports reaching a six-month high
                        of $45.2 billion, even as global economic uncertainty
                        and a wider trade deficit persist.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        The <strong>National Stock Exchange</strong> has filed
                        its draft prospectus for a proposed ₹30,000 crore IPO —
                        nearly a decade after its first attempt — in what is
                        primarily framed as a value-unlocking exercise rather
                        than a capital raise.
                      </span>
                    </li>
                  </ul>
                </div>

                {/* ── Section 5: Travel ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag red">
                      ✈️ Travel &amp; Mobility Trends
                    </span>
                  </div>

                  <ul className="news-bullets">
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>Jet fuel prices ease.</strong> India cut
                        Aviation Turbine Fuel prices by roughly ₹5 a litre to
                        ₹110 on July 1 — the first reduction since the West Asia
                        conflict pushed fuel costs to record highs — offering
                        airlines relief and travelers a chance at modestly
                        cheaper fares in the months ahead.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>Air India trims fuel surcharges</strong> on
                        international routes, cutting the levy on North America
                        and Australia flights from $280 to $200, and on Europe
                        and UK routes from $205 to $125 — welcome news for
                        Bharat expatriates booking long-haul travel home.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        Industry watchers caution the relief is likely a
                        short-term cycle tied to easing crude prices rather than
                        a structural shift, so travelers should still book early
                        and compare fares across carriers.
                      </span>
                    </li>
                  </ul>
                </div>
              </main>

              {/* ══ SIDEBAR ══ */}
              <aside className="news-sidebar">
                {/* Quick Facts widget */}
                <div className="sidebar-widget">
                  <div className="sidebar-widget-head">
                    This Week at a Glance
                  </div>
                  <ul className="quick-facts">
                    {[
                      "PM Modi tours Indonesia, Australia & New Zealand",
                      "India-Japan summit: $10B+ investment, AI pact",
                      "EB-2 visa quota exhausted for FY2026",
                      "Canada cuts student permits 7%, ends SDS",
                      "India trails England 0-1 in T20I series",
                      "IBM quantum computer coming to Amaravati",
                      "ATF jet fuel price cut to ₹110/litre",
                    ].map((fact) => (
                      <li key={fact}>
                        <span className="qf-bullet" />
                        <span>{fact}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Stat widget */}
                <div className="sidebar-widget">
                  <div className="sidebar-widget-head">Numbers to Know</div>
                  <div className="stat-widget">
                    {[
                      { label: "EB-2 Quota", val: "0 left", delta: "FY2026" },
                      {
                        label: "Canada Permits",
                        val: "408K",
                        delta: "-7% vs 2025",
                      },
                      { label: "ATF Price", val: "₹110/L", delta: "-₹5 cut" },
                    ].map((s) => (
                      <div className="stat-widget-item" key={s.label}>
                        <div>
                          <div className="stat-widget-label">{s.label}</div>
                          <div className="stat-widget-delta">{s.delta}</div>
                        </div>
                        <div className="stat-widget-val">{s.val}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ── Single Ad Unit in sidebar ── */}
                <div className="sidebar-widget">
                  <AdUnit />
                </div>
              </aside>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default BharatAbroadWeeklyNewsletter;
